import React from "react";
import { Tabs, Tab, Paper } from "@mui/material";
import {
  Outlet,
  useLocation,
  useMatch,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import { ShippingCaseResponse } from "@pages/shippingView/types";
import { CUSTOMS_CONTROL_PROTOCOL_FEATURE } from "@pages/shippingView/tabs/customs/config";

export default function CustomsLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const { shipping } = useOutletContext<{ shipping: ShippingCaseResponse }>();

  const fullTabs = [
    { label: "Control Protocols", path: "control-protocols" },
    { label: "Radiometric check", path: "radiometric" },
    { label: "Custom bill listing", path: "bills" },
  ];

  const restrictedTabs = [
    { label: "Radiometric check", path: "radiometric" },
    { label: "Custom bill listing", path: "bills" },
  ];

  const tabs = CUSTOMS_CONTROL_PROTOCOL_FEATURE ? fullTabs : restrictedTabs;

  const activeTab = tabs.findIndex((t) =>
    location.pathname.includes(`/customs/${t.path}`),
  );

  const isBillDetails = useMatch(
    "/offers/:oid/shipping-case/:sid/customs/bills/:id",
  );
  const isBillCreate = useMatch(
    "/offers/:oid/shipping-case/:sid/customs/bills/create",
  );

  return (
    <>
      {!isBillDetails && !isBillCreate && (
        <Tabs
          className="cargo"
          value={activeTab === -1 ? 0 : activeTab}
          onChange={(_, val) => navigate(tabs[val].path)}
        >
          {tabs.map((t) => (
            <Tab key={t.path} label={t.label} />
          ))}
        </Tabs>
      )}

      <Paper
        elevation={0}
        sx={{
          ...(!isBillDetails && !isBillCreate
            ? {
                p: "16px",
                border: "1px solid rgba(0, 0, 0, 0.12)",
                borderRadius: "0 4px 4px 4px",
              }
            : {}),
        }}
      >
        <Outlet context={{ tabLabels: tabs, activeTab, shipping }} />
      </Paper>
    </>
  );
}
